import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import {FormControl, FormGroup} from '@angular/forms';
import { ReactivosService } from "app/main/wizard-cgo/services/reactivos.service";
import { IdiomasService } from 'app/main/wizard-cgo/services/idiomas.service';
import * as backInter from 'app/auth/auth-data.model';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { AdicionalesService } from 'app/main/wizard-cgo/services/adicionales.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
@Component({
  selector: 'traducciones',
  templateUrl: './traducciones.component.html',
  styleUrls: ['./traducciones.component.scss'],
  animations : fuseAnimations
})
export class TraduccionesComponent implements OnInit {

  formGroups: FormGroup[] = [];
  fgListo: boolean;
  cargando = true;
  sinReactivos: boolean;
  guardados: any;
  idiomas: any[] = [];
  @Output() sindiomasAdicionales: EventEmitter<boolean> = new EventEmitter();

  idsPlantillas: any[] = [];
  reactivosPlantillas: any[] = [];

  reactivosMostrar: any[] = [];
  preguntasTraduccionesAdicionalesFocus: backInter.respuestaTraduccionesPreguntasAdicionalesFocus;
  numeroTextosTraduccion: number[] = [];
  textosPreguntasFiltrados: any[] = [];
  @Output() actualizarAdicionales: EventEmitter<boolean> = new EventEmitter();


  mensajesTraducirKeys: string[] = [
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.PREG_OK',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.PREG_ERR',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.PREG_MOD_OK',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.PREG_MOD_ERR',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_NOPREG',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_OK',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_ERR',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_MOD_OK',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_MOD_ERR'
  ]

  mensajesTraducirTS = {
    preg_ok: '',
    preg_err: '',
    preg_mod_ok: '',
    preg_mod_err: '',
    opc_nopreg: '',
    opc_ok: '',
    opc_err: '',
    opc_mod_ok: '',
    opc_mod_err: ''
  };

  constructor(
    private reactivosService: ReactivosService,
    private idiomasService: IdiomasService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private adicionalesService: AdicionalesService,
    private _snackBar: MatSnackBar,
    private translateSrv: TranslateService,
  ) {
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
  }

  ngOnInit() {
    this.getIdiomas();
    this.obtieneTraduccionesAdicionalesFocus();
    this.traduceTextosTS();
    // this.getReactivosGuardados();
  }

  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  getIdiomas(){
    this.idiomasService.getListaIdiomasFocus().subscribe( (data: any) => {
      console.log(data);
      data.idiomas.forEach(idioma => {
        if(idioma.tipoIdioma == 0){
          this.idiomas.push(idioma);
        }
      });
      // this.idiomas = data.idiomas;
      this.getReactivosGuardados();
    });
  }

  getReactivosGuardados(){
    this.reactivosService.getGuardados(localStorage.getItem('encuestaID')).subscribe((respuesta:any) => {
      console.log(respuesta);
      this.guardados = respuesta;
      this.creaFormGroups();
      if(this.guardados.preguntas.length == 0){
        this.sinReactivos = true;
        // this.cargando = false;
      }
      else{
        this.guardados.preguntas.forEach(pregunta => {
          console.log(pregunta);

          let indice = this.idsPlantillas.findIndex(item => item.idPlantilla === pregunta.plantillaId);
          if(indice == -1){
            this.idsPlantillas.push(
              {
                idPlantilla: pregunta.plantillaId,
                obtenido: false
              }
            );
          }
        });
        console.log(this.idsPlantillas);
        this.idsPlantillas.forEach(idPlantilla => {
          this.getReactivosPlantilla(idPlantilla.idPlantilla);
        });
      }
    });
  }
  getReactivosPlantilla(plantillaId:string){
    let datos = {
      encuestaID: localStorage.getItem('encuestaID'),
      idPlantilla: plantillaId
    }
    this.reactivosService.getReactivos(datos).subscribe((respuesta:any) => {
      // console.log(respuesta);
      if(respuesta.success){
        this.reactivosPlantillas.push(respuesta);
      }
      console.log("reactivosplants:",this.reactivosPlantillas);

      let filtrarReactivos = true;
      this.idsPlantillas.forEach(plantilla => {
        if(plantilla.idPlantilla == plantillaId){
          plantilla.obtenido = true;
        }
        if(!plantilla.obtenido){
          filtrarReactivos = false;
        }
      });
      if(filtrarReactivos){
        console.log("a filtrar prro");
        this.filtraReactivosTraduccion();
      }
      else{
        console.log("aun no xd");
      }

    });
  }



  filtraReactivosTraduccion(){
    this.guardados.preguntas.forEach(pregunta => {
      let indicePlantilla = this.reactivosPlantillas.findIndex(item => item.idPlantilla === pregunta.plantillaId);
      if(indicePlantilla != -1){
        let indiceReactivo = this.reactivosPlantillas[indicePlantilla].reactivosNat.findIndex(item => item.pregunta === pregunta.pregunta);
        if(indiceReactivo != -1){
          let reactivoNativo = this.reactivosPlantillas[indicePlantilla].reactivosNat[indiceReactivo];
          let reactivosAdicionales: any[] = [];
          this.reactivosPlantillas[indicePlantilla].reactivosAdic.forEach(adicional => {

            if(adicional.id == reactivoNativo.id){
              reactivosAdicionales.push(adicional);
            }
          });
          let reactivoMostrar:any = {
            id: reactivoNativo.id,
            nativo: reactivoNativo.pregunta,
            idPlantilla: pregunta.plantillaId,
            idPregunta:  pregunta._id,
            orden: pregunta.orden,

          };
          reactivosAdicionales.forEach(adicional => {
            reactivoMostrar[adicional.clave] = adicional.pregunta;
          });
          this.idiomas.forEach(idioma => {
            if(!reactivoMostrar[idioma.clave]){
              reactivoMostrar[idioma.clave] = null;
              reactivoMostrar.mostrar=false;

            }else{
              reactivoMostrar.mostrar=true;
            }

          });
          this.reactivosMostrar.push(reactivoMostrar);
        }
      }
    });
    console.log("reactivosmostrar:",this.reactivosMostrar);
    // this.cargando = false;
  }

  creaFormGroups(){
    this.formGroups = [];
    this.idiomas.forEach((idioma,i) => {
      let group = {};
      this.guardados.preguntas.forEach((pregunta,j) => {
        group["traduccion"+j] = new FormControl('');
      });
      this.formGroups.push(new FormGroup(group));
    });
    console.log(this.formGroups);
  //   if (this.formGroups.length>0) {
  //   this.sindiomasAdicionales.emit(true);
  //   console.log("entro este visne ");
  //
  // }else{
  //     this.sindiomasAdicionales.emit(false);
  // }
    this.fgListo = true;
  }

  cambioIdioma(event){
    console.log("evento:",event);

  }

  obtieneTraduccionesAdicionalesFocus(){
    let datos:any= {seccion: 2, empresaId:localStorage.getItem('companyID')};
    this.adicionalesService.getTraduccionesAdicionalFocus(datos).subscribe( (data:any) => {
      this.preguntasTraduccionesAdicionalesFocus=data;
      console.log(data)
      this.filtraTextosIdiomaPrincipalFocus();

});
}


  filtraTextosIdiomaPrincipalFocus(){

    console.log(this.preguntasTraduccionesAdicionalesFocus);
    let numeroOpcionAdicional=0;
    this.preguntasTraduccionesAdicionalesFocus.arrayMostrar.forEach( (adicional) => {
    let preguntas: any[]=[];
      adicional.preguntas.forEach( (textos) => {
        let numeroTextos=0;
        numeroTextos++;
        console.log(textos);
        if(textos.tipoRespuesta!=3){
          let  objetoTextoAdicional = {
            textoPregunta : textos.pregunta,
            tipoPregunta : textos.tipoAgregado,
            opcionesResp : textos.opciones,
            orden: textos.orden,
            tipoRespuesta: textos.tipoRespuesta,
            seccion: textos.seccion,
            requerido: textos.requerido,
            _id: textos._id,
            traduccion: textos.traduccion

          };
        preguntas.push(objetoTextoAdicional);
        numeroTextos+= textos.opciones.length;
        console.log(numeroTextos);
}else{
console.log("es de tipo 3 ");

}

        this.numeroTextosTraduccion.push(numeroTextos);

    });
      this.textosPreguntasFiltrados.push(
      {
        clave:   adicional.clave,
        idiomaId: adicional.idiomaId,
        preguntas: preguntas,
      });
        numeroOpcionAdicional++;
      console.log("textosPregFilt:",this.textosPreguntasFiltrados);
      this.cargando = false;
    });


  }



  guardaTraduccion(event:any,idTraduccion:string, idIdioma: string,orden: any,datos:any){
    console.log(datos);
    console.log(idTraduccion);

    if(event.target.value.length > 0){
        console.log("si mando texto");

      if(idTraduccion && datos.traduccion !=""){
        this.updateTraduccionReactivo(event,idTraduccion,idIdioma,orden)
        console.log("entro la de Actualizar x2");
      }
      else{
          console.log("entro la de guardar");
        this.guardaTraduccionBD(event,idTraduccion,idIdioma,orden);

      }
    }
  }




  updateTraduccionReactivo(event,idTraduccion,idIdioma,orden){
    let traduccion:any={
      empresaId: localStorage.getItem('companyID'),
      preguntaId: idTraduccion,
      pregunta:event.target.value,
      idiomaId: idIdioma,
      orden:orden
    }
    console.log("la preguntaa traducir: ",traduccion);
    this.adicionalesService.actualizaAdicionalTraduccionesFocus(traduccion).subscribe( (data:any) => {
      if(data.success){
       this.openSnackBar(this.mensajesTraducirTS.preg_mod_ok, "OK");
       this.actualizarAdicionales.emit(true);
       }
      else
      this.openSnackBar(this.mensajesTraducirTS.preg_mod_err, "OK");
      // console.log(data);
    });

  }


  guardaTraduccionBD(event,idTraduccion,idIdioma,orden){
    let traduccion = {} as backInter.nuevoAdicionalFocus;
    traduccion.preguntaId = idTraduccion;
    traduccion.pregunta = event.target.value;
    traduccion.idiomaId = idIdioma;
    traduccion.empresaId = localStorage.getItem('companyID');


    this.adicionalesService.guardaTraduccionAdicionalFocus(traduccion).subscribe( (data: any) => {
      console.log(data);
      if(data.success){
        // this.idsTraduccionesBD.push({idTraduccion:data.traduccionMostrar._id, identificador:identificador, idIdioma:idIdioma});
        this.openSnackBar(this.mensajesTraducirTS.preg_ok, "OK");
        this.actualizarAdicionales.emit(true);
      }
      else this.openSnackBar(this.mensajesTraducirTS.preg_err, "OK");
    });
  }
}
